import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';
import { IWorkbookBase } from '~src/workbook/models/IWorkbookInfo';
import { Workbooks } from '~src/workbook/resources/Workbooks';
import { WorkbookErrors } from '~src/workbook/services/WorkbookErrors';

export namespace ChangeWorkbookDescriptionAction {
  export function execute(workbook: IWorkbookBase, newDescription: string): Promise<IResult> {

    return Workbooks.setDescription(workbook.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: WorkbookErrors.errorMessageFor({ item: workbook, error: result.errors[0] })
        });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });
  }
}

export type ChangeWorkbookDescriptionAction = typeof ChangeWorkbookDescriptionAction;
